/** Invitation bearer material never belongs in storage, router state or telemetry. */
export const INVITATION_ACCEPT_PATH = '/invitations/accept';
let initialToken: string | null = null;
let initialInvitationId: string | null = null;

export function captureInvitationContext(): void {
  if (typeof window === 'undefined' || window.location.pathname !== INVITATION_ACCEPT_PATH) return;
  const params = new URLSearchParams(window.location.search);
  const tokens = params.getAll('invite_token');
  const states = params.getAll('state');
  if (params.has('invite_token') || params.has('state')) forgetInvitationToken();
  if (tokens.length === 1 && tokens[0] && tokens[0].length <= 8192 && states.length === 1 && /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(states[0])) {
    initialToken = tokens[0];
    initialInvitationId = states[0];
  }
  // Strip every query/fragment, including recipient and provider error fields,
  // before Sentry initializes or any component reads the page location.
  if (window.location.search || window.location.hash) {
    window.history.replaceState({}, document.title, INVITATION_ACCEPT_PATH);
  }
}

export function invitationTokenForExchange(): string | null { return initialToken; }
export function invitationIdForExchange(): string | null { return initialInvitationId; }
export function forgetInvitationToken(): void { initialToken = null; initialInvitationId = null; }

// index.tsx imports this module first. Do not introduce imports with side effects.
captureInvitationContext();
